export default function NotFound() {
    return (
        <div className="not-found">
            <span>Page Not Found</span>
        </div>
    )
}